import { faCompress, faExpand } from '@fortawesome/pro-regular-svg-icons';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useCallback } from 'react';
import { PlayerControlButton } from './base-button';
import { useVideoPlayerContext } from '../../player-context';

export const FullScreen = () => {
  const { playerRef } = useVideoPlayerContext();
  const remote = useMediaRemote(playerRef);
  const isFullscreen = useMediaState('fullscreen', playerRef!);
  const handleToggleFullscreen = useCallback(() => {
    remote.toggleFullscreen();
  }, [remote]);

  return (
    <PlayerControlButton
      icon={isFullscreen ? faCompress : faExpand}
      onClick={handleToggleFullscreen}
    />
  );
};
